import React from 'react'
import parse, { domToReact, HTMLReactParserOptions } from 'html-react-parser'
import { Avatar, Layout } from 'components/ProductSelector'
import { Section, Container } from 'app/sofia/scenes/ProductSelector/styled'
import { Button } from 'lib/ui'
import { Wrapper } from './styled'
import { useCmsBlock } from 'lib/core/hooks'
import { CMS_BLOCK } from 'app/sofia/resources/constants'

interface Props {
  setShowLanding: (param: boolean) => void
}

export const Introduction = ({ setShowLanding }: Props) => {
  const staticBlock = useCmsBlock({
    id: CMS_BLOCK.PPQ_INTRO,
    isLazy: false
  })

  if (!staticBlock.content) return null

  const options: HTMLReactParserOptions = {
    replace: (domNode: any) => {
      const { attribs, children } = domNode

      if (!attribs) {
        return
      }

      if (attribs.id === 'trigger') {
        return <Button onClick={() => setShowLanding(false)}>{domToReact(children, options)}</Button>
      }
    }
  }

  return (
    <Layout>
      <>
        <Avatar isLanding />
        <Section className='intro'>
          <Container>
            <Wrapper>
              {staticBlock.content && (
                <div>
                  {parse(staticBlock.content, options)}
                </div>
              )}
            </Wrapper>
          </Container>
        </Section>
      </>
    </Layout>
  )
}
